import clsx from 'clsx'
import { Button, Grid, Icon } from 'gu-ui-kit'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import Logo from 'layouts/subcomponents/Logo'
import styles from 'components/Header/Header.module.scss'
import TicketsCounter from 'components/Header/subcomponents/TicketsCounter'
import { ROUTES } from 'constants/routes'
import BalanceWidget from 'components/Drawer/subcomponents/BalanceWidget'
import PropTypes from 'prop-types'
import { SET_DRAWER_STATE } from 'modules/App/types'
import { selectAppDrawerState } from 'modules/App/store/selectors'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { useAuthState } from 'modules/Auth/hooks/useAuthState'

const Header = ({
  className = '',
  showSidebarToggle = true,
  hasBalance = true,
  faqPath = ROUTES.FAQ,
  openFaqInNewTab = true,
  alwaysShowActions = false,
}) => {
  const { isAuthenticated } = useAuthState()
  const drawerState = useSelector(selectAppDrawerState)
  const breakpoints = useBreakpoint()
  const dispatch = useDispatch()
  const { t } = useTranslation(['common'])
  const pathGen = useGeneratePathI18n()
  const showActions = alwaysShowActions || breakpoints.sm

  return (
    <Grid
      component={'header'}
      className={clsx(styles['header'], 'layout-tile', className)}
    >
      <Grid
        alignItems={'center'}
        justifyContent={'between'}
        className={styles['header__width-wrapper']}
      >
        <Grid
          fluid={false}
          component={'nav'}
          gap={16}
          direction={'row'}
          wrap={false}
        >
          <Grid
            fluid={false}
            className={styles['header__logo']}
          >
            <Logo />
          </Grid>

          {isAuthenticated && showSidebarToggle && (
            <Button
              className={styles['header__sidebar-toggle']}
              variant={'ghost'}
              grey
              title={t(
                drawerState.opened
                  ? 'common::header.sidebar_toggle_close'
                  : 'common::header.sidebar_toggle_open',
              )}
              onPointerDown={(e) => {
                e.preventDefault()

                dispatch({
                  type: SET_DRAWER_STATE,
                  payload: {
                    opened: !drawerState.opened,
                  },
                })
              }}
              noLabel
              size={'s'}
              startIcon={<Icon name={drawerState.opened ? 'close' : 'burger'} />}
            />
          )}
        </Grid>

        <Grid
          wrap={false}
          gap={16}
          justifyContent={'end'}
          alignItems={'center'}
          fluid={false}
        >
          <Grid
            gap={16}
            wrap={false}
            fluid={false}
            alignItems={'center'}
          >
            {hasBalance && (
              <BalanceWidget
                minimalistic={!breakpoints.sm}
                className={styles['header__balance-widget']}
                small={true}
              />
            )}

            {showActions && (
              <>
                <Button
                  component={'a'}
                  size={'s'}
                  variant={'ghost'}
                  grey
                  color={'Interface-Eight'}
                  title={t('common::header.faq_link')}
                  startIcon={<Icon name={'question'} />}
                  {...(openFaqInNewTab ? { target: '_blank' } : {})}
                  href={pathGen(faqPath)}
                />
                <TicketsCounter />
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Header

Header.propTypes = {
  className: PropTypes.string,
  showSidebarToggle: PropTypes.bool,
  hasBalance: PropTypes.bool,
  faqPath: PropTypes.string,
  openFaqInNewTab: PropTypes.bool,
  alwaysShowActions: PropTypes.bool,
}
